import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const SolutionsPage = lazy(() => import('../pages/solutions/page'));
const ProductsPage = lazy(() => import('../pages/products/page'));
const ProductDetailPage = lazy(() => import('../pages/product-detail/page'));
const ProductOrderPage = lazy(() => import('../pages/product-order/page'));
const PartnersPage = lazy(() => import('../pages/partners/page'));
const QualityPage = lazy(() => import('../pages/quality/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const InscriptionPage = lazy(() => import('../pages/inscription/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Legal pages
const MentionsLegalesPage = lazy(() => import('../pages/legal/mentions-legales/page'));
const PolitiqueConfidentialitePage = lazy(() => import('../pages/legal/politique-confidentialite/page'));
const PolitiqueCookiesPage = lazy(() => import('../pages/legal/politique-cookies/page'));
const ConditionsUtilisationPage = lazy(() => import('../pages/legal/conditions-utilisation/page'));
const ProtectionDonneesPage = lazy(() => import('../pages/legal/protection-donnees/page'));

// Admin pages
const AdminLoginPage = lazy(() => import('../pages/admin/login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin/dashboard/page'));

// Client pages
const ClientLoginPage = lazy(() => import('../pages/client/login/page'));
const ClientDashboardPage = lazy(() => import('../pages/client/dashboard/page'));

// Distributor pages
const DistributorLoginPage = lazy(() => import('../pages/distributor/login/page'));
const DistributorDashboardPage = lazy(() => import('../pages/distributor/dashboard/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/solutions',
    element: <SolutionsPage />,
  },
  {
    path: '/products',
    element: <ProductsPage />,
  },
  {
    path: '/products/:slug',
    element: <ProductDetailPage />,
  },
  {
    path: '/products/:slug/order',
    element: <ProductOrderPage />,
  },
  {
    path: '/partners',
    element: <PartnersPage />,
  },
  {
    path: '/quality',
    element: <QualityPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/inscription',
    element: <InscriptionPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboardPage />,
  },
  {
    path: '/client/login',
    element: <ClientLoginPage />,
  },
  {
    path: '/client/dashboard',
    element: <ClientDashboardPage />,
  },
  {
    path: '/distributor/login',
    element: <DistributorLoginPage />,
  },
  {
    path: '/distributor/dashboard',
    element: <DistributorDashboardPage />,
  },
  {
    path: '/legal/mentions-legales',
    element: <MentionsLegalesPage />,
  },
  {
    path: '/legal/politique-confidentialite',
    element: <PolitiqueConfidentialitePage />,
  },
  {
    path: '/legal/politique-cookies',
    element: <PolitiqueCookiesPage />,
  },
  {
    path: '/legal/conditions-utilisation',
    element: <ConditionsUtilisationPage />,
  },
  {
    path: '/legal/protection-donnees',
    element: <ProtectionDonneesPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
